import { useSyncExternalStore } from 'react';

/** Samma brytpunkt som Tailwinds `lg` — där spalten slutar vara en utfälld mobilmeny. */
const FRAGA = '(min-width: 1024px)';

function prenumerera(andrad: () => void) {
  const mq = window.matchMedia(FRAGA);
  mq.addEventListener('change', andrad);
  return () => mq.removeEventListener('change', andrad);
}

/**
 * Sant på dator (lg och uppåt). Behövs där CSS inte räcker: `inert` och
 * minimeringsläget måste veta brytpunkten i JS, annars blir en dold mobilmeny
 * kvar i tabbordningen och ett minimerat läge från datorn följer med till mobilen.
 */
export function useStorSkarm(): boolean {
  return useSyncExternalStore(
    prenumerera,
    () => window.matchMedia(FRAGA).matches,
    () => true,
  );
}
